"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = void 0;
var _core = require("@dragon/core");
require("./Overlay.scss");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Overlay = exports.Overlay = /*#__PURE__*/function () {
  function Overlay(parent, onClick) {
    var _this = this;
    _classCallCheck(this, Overlay);
    _defineProperty(this, "_node", void 0);
    _defineProperty(this, "show", function () {
      _this._node.classList.add("show");
    });
    _defineProperty(this, "hide", function () {
      _this._node.classList.remove("show");
    });
    this._node = document.createElement("div");
    this._node.className = "uiOverlay";
    parent.appendChild(this._node);
    this._node.onclick = onClick;

    /** This is a big difference from how the overlay in default desktop work. Its needed since ui is outside the game container. 
     * Should likely be rewritten
     */
    _core.CORE.subscribe('config.screenSize', function (s) {
      _this._node.style.height = s.height + 'px';
      _this._node.style.width = s.width + 'px';
    });
  }
  return _createClass(Overlay, [{
    key: "getNode",
    value: function getNode() {
      return this._node;
    }
  }]);
}();
//# sourceMappingURL=Overlay.js.map